<template>
  <el-container class="hotellist-main" id="main">
    <publicHeader @setCollapse="setCollapse" @getPermissions="getPermissions"></publicHeader>
    <div class="main-content">
      <publicMenu :isCollapse="isCollapse" :allPermissions="allPermissions"></publicMenu>
      <div class="content">
        <slot>
          <el-main>
            <div class="home-center">
              <div class="coupon-list" :style="heightCss">
                <el-skeleton animated :loading="couponShow">
                  <template slot="template">
                    <div class="couponlist">
                        <div class="width-discount"><el-skeleton-item variant="text" class="template-text" /></div>
                        <div class="width-type"><el-skeleton-item variant="text" class="template-text" /></div>
                        <div class="width-price"><el-skeleton-item variant="text" class="template-text" /></div>
                        <div class="width-validity"><el-skeleton-item variant="text" class="template-text" /></div>
                        <div class="width-checkin"><el-skeleton-item variant="text" class="template-text" /></div>
                        <div class="width-checkout"><el-skeleton-item variant="text" class="template-text" /></div>
                        <div class="width-button"><el-skeleton-item variant="text" class="template-text" /></div>
                    </div>
                  </template>
                  <template>
                    <el-card :body-style="{ padding: '0px' }">
                      <div class="type-list">
                        <div :class="{'gray-background': type === 'Unredeemed'}" @click="clickActive('Unredeemed')">Unredeemed</div>
                        <div :class="{'gray-background': type === 'Redeemed'}" @click="clickActive('Redeemed')">Redeemed</div>
                        <div :class="{'gray-background': type === 'Expired'}" @click="clickActive('Expired')">Expired</div>
                      </div>
                      <div class="couponlist">
                        <div class="width-discount">Discounts and Immediate Deductions</div>
                        <div class="width-type">Type</div>
                        <div class="width-price">Usage Limit on Amount</div>
                        <div class="width-validity">Validity period</div>
                        <div class="width-checkin">Checkin</div>
                        <div class="width-checkout">Checkout</div>
                        <div class="width-button"></div>
                      </div>
                    </el-card>
                  </template>
                </el-skeleton>
                <el-skeleton :count="10" animated :loading="couponShow">
                  <template slot="template">
                    <div class="hotel-info">
                      <div class="width-discount"><el-skeleton-item variant="text" class="template-info-text" /></div>
                      <div class="width-type"><el-skeleton-item variant="text" class="template-info-text" /></div>
                      <div class="width-price"><el-skeleton-item variant="text" class="template-info-text" /></div>
                      <div class="width-validity"><el-skeleton-item variant="text" class="template-info-text" /></div>
                      <div class="width-checkin"><el-skeleton-item variant="text" class="template-info-text" /></div>
                      <div class="width-checkout"><el-skeleton-item variant="text" class="template-info-text" /></div>
                      <div class="width-button"><el-skeleton-item variant="text" style="font-size: 13px; width: 100px; height: 30px;margin: 10px 0; float: right;" class="template-info-text" /></div>
                    </div>
                  </template>
                  <template>
                    <div class="hotel-info" v-for="(value, key) in myCouponList" :key="key" v-show="!couponEmptyShow">
                      <div class="width-discount" style="height: 60px;">{{value.coupon_val}} off&nbsp;</div>
                      <div class="width-type" style="height: 60px;">{{value.type}}</div>
                      <div class="width-price" style="height: 60px;">{{value.limit_price_val}}</div>
                      <div class="width-validity" style="height: 60px;">{{value.validity_period}}</div>
                      <div class="width-checkin" style="height: 60px;" v-if="value.checkin === '-'">
                        <div style="width: 55px; text-align: center;">{{value.checkin}}</div>
                      </div>
                      <div class="width-checkin" style="height: 60px;" v-else>{{value.checkin}}</div>
                      <div class="width-checkout" style="height: 60px;" v-if="value.checkout === '-'">
                        <div style="width: 55px; text-align: center;">{{value.checkout}}</div>
                      </div>
                      <div class="width-checkout" style="height: 60px;" v-else>{{value.checkout}}</div>
                      <div class="width-button" style="height: 60px;">
                        <button type="button" class="booknow_button view_button" @click="gotoHome" v-show="UnredeemedShow">Use Now</button>
                        <!-- <button type="button" class="booknow_button view_button" style="background: rgba(140, 140, 140, 1); border-color: rgba(140, 140, 140, 1);" v-show="RedeemedShow">Used</button>
                        <button type="button" class="booknow_button view_button" style="background: rgba(140, 140, 140, 1); border-color: rgba(140, 140, 140, 1);" v-show="ExpiredShow">Expired</button> -->
                      </div>
                    </div>
                    <div style="height: 140px;" v-show="!couponEmptyShow"></div>
                    <div class="hotel-info" style="width: 100%; text-align: center; border: none;" v-show="couponEmptyShow">
                      <img src="/static/img/account/empty.png" style="width: 160px; height: 160px; margin-top: 80px;opacity: 0.25;">
                      <div class="empty-txt">You have no coupons~</div>
                    </div>
                  </template>
                </el-skeleton>
              </div>
            </div>
          </el-main>
        </slot>
        <publicFooter :source="source"></publicFooter>
      </div>
    </div>
  </el-container>
</template>

<script scoped>
import { myCoupon } from '@/request/coupon.js'
import publicFooter from '@/components/public/publicFooter'
import publicSearch from '@/components/public/publicSearch'
import publicHeader from '@/components/public/publicHeader'
import publicMenu from '@/components/public/publicMenu'
export default {
  name: 'myCoupon',
  components: {
    publicFooter,
    publicHeader,
    publicSearch,
    publicMenu
  },
  props: [],
  data () {
    return {
      myCouponList: {},
      myUnredeemedCouponList: {},
      myRedeemedCouponList: {},
      myExpiredCouponList: {},
      couponShow: false,
      couponEmptyShow: false,
      language: this.common.languageSet(this),
      currency: this.common.currencySet(this),
      elementHeight: 0,
      resultCurrency: '',
      currencyShow: false,
      UnredeemedShow: true,
      RedeemedShow: false,
      ExpiredShow: false,
      explainZhDia: false,
      explainShowClose: false,
      explainEnDia: false,
      cancelEnDia: false,
      cur: '',
      couponLoading: true,
      allPermissions: {'email': '', 'phone_internal': '', 'phone_external': ''},
      source: 'roompai',
      isCollapse: this.common.collapseSet(),
      contentWidth: document.body.clientWidth - 74,
      type: 'Unredeemed',
      heightCss: {'min-height': '500px'},
      mainMinHeight: document.documentElement.clientHeight - 75
    }
  },
  created () {
    this.beforeMount()
  },
  mounted: function () {
    this.heightCss = {'min-height': this.mainMinHeight + 'px'}
    // 判断来源
    this.source = this.common.sourceSet()
    var source = this.common.sourceSet()
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
      var sourceExpiresAt = Date.now() + 3600000 * 5
      localStorage.setItem('source', this.source)
      localStorage.setItem('sourceExpiresAt', sourceExpiresAt)
    } else {
      source = this.$route.query.source
      var sourceExpires = localStorage.getItem('sourceExpiresAt')
      if (sourceExpires !== '' && sourceExpires !== undefined && sourceExpires !== null) {
        var nowTime = Date.now()
        if (nowTime > sourceExpires) {
          localStorage.removeItem('source')
          localStorage.removeItem('sourceExpiresAt')
        } else {
          // 避免手动干预删除或者修改localStorage
          if (source === '' || source === undefined || source === null) {
            localStorage.removeItem('source')
            localStorage.removeItem('sourceExpiresAt')
          } else {
            this.source = source
            this.common.sourceSet(source)
          }
        }
      }
    }
    if (this.source === '' || this.source === undefined || this.source === null) {
      let locationHref = window.document.location.href
      localStorage.setItem('LoginWebsiteAddress', locationHref)
      this.$router.push({name: 'login'})
    }
    this.getMyCoupon()
  },
  watch: {
    currency: function (newCur, oldCur) {
      this.getMyCoupon()
      this.clickActive('Unredeemed')
    },
    language: function (newCur, oldCur) {
      this.getMyCoupon()
      this.clickActive('Unredeemed')
    }
  },
  methods: {
    getPermissions (value) {
      this.allPermissions = value
    },
    setCollapse (value) {
      this.isCollapse = value
      if (value === false) {
        this.contentWidth = document.body.clientWidth - 260
      } else {
        this.contentWidth = document.body.clientWidth - 74
      }
    },
    beforeMount () {
      this.elementHeight = document.documentElement.clientHeight || document.body.clientHeight
    },
    hotelDetailCurrency (currency) {
      this.currency = currency
    },
    hotelLanguage (language) {
      this.language = language
    },
    getMyCoupon () {
      this.couponShow = true
      this.common.stopScroll()
      var time = parseInt(new Date().getTime() / 1000)
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        let locationHref = window.document.location.href
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        if (this.source !== '') {
          this.$router.push({name: 'login', query: {'source': this.source}})
        } else {
          this.$router.push({name: 'login'})
        }
      }
      var sessionid = this.common.sessionidGet(this)

      var dataJson = {'source': this.source, 'time': time, 'token': token, 'sessionid': sessionid, 'currency': this.currency}
      var data = this.common.encryptionData(dataJson, this)
      myCoupon(data).then(res => {
        if (res.flag === '001') {
          let locationHref = window.document.location.href
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          this.$router.push({name: 'login', query: {'source': this.source}})
        } else if (res.flag === '200' && res.data !== '') {
          this.myUnredeemedCouponList = res.data.list.Unredeemed
          this.myRedeemedCouponList = res.data.list.Redeemed
          this.myExpiredCouponList = res.data.list.Expired
          this.myCouponList = this.myUnredeemedCouponList
          this.couponShow = false
          this.couponEmptyShow = false
          this.couponLoading = false
          this.resultCurrency = res.data.currency
        } else {
          this.myUnredeemedCouponList = {}
          this.myRedeemedCouponList = {}
          this.myExpiredCouponList = {}
          this.myCouponList = {}
          this.couponShow = false
          this.couponEmptyShow = true
          this.couponLoading = false
        }
      })
      this.couponShow = false
      this.common.canScroll()
    },
    clickActive: function (type) {
      this.type = type
      // 默认都不展示.
      this.UnredeemedShow = false
      this.RedeemedShow = false
      this.ExpiredShow = false
      // 指定的tab显示为true.
      if (type === 'Unredeemed') {
        this.UnredeemedShow = true
        this.myCouponList = this.myUnredeemedCouponList
      } else if (type === 'Redeemed') {
        this.RedeemedShow = true
        this.myCouponList = this.myRedeemedCouponList
      } else if (type === 'Expired') {
        this.ExpiredShow = true
        this.myCouponList = this.myExpiredCouponList
      }
      if (this.myCouponList === 'undefined' || this.myCouponList === undefined || JSON.stringify(this.myCouponList) === '{}') {
        this.couponShow = false
        this.couponEmptyShow = true
      } else {
        this.couponEmptyShow = false
        this.couponShow = false
      }
    },
    gotoHome () {
      this.$router.push({path: '/portal/booking/hotelsearch/HotelList', query: {'source': this.source}})
    },
    explainZhDiaShow (key) {
      this.cur = key
      this.explainZhDia = true
    },
    explainEnDiaShow (key) {
      this.cur = key
      this.explainEnDia = true
    }
  }
}
</script>
<style type="text/css" scoped>
  /* .home-center{height: auto;} */
  body > .el-container {margin-bottom: 40px;}
  .el-container{display:block;}
  /* 搜索 */
  .search{ height:100px; background: #FFF; border-radius: 5px;}
  .search-info{ height: 48px; padding: 26px 15px;}
  .hotellist-region{float: left;margin-right:5px;}
  .hotellist-region input, .search-status input{background-color:rgba(255,255,255,1);background-image:url(/static/img/account/icon_u24.png);background-repeat:no-repeat;background-size: 20px;background-position: 12px center;padding: 0px 50px;width: 100%; height: 48px;font-size: 16px;opacity:1;}
  .hotellist-region /deep/ .el-input__inner:focus,.hotellist-region input:focus, .search-status /deep/ .el-input__inner:focus,.search-status input:focus{border-color:rgba(83, 102, 163, 1);box-shadow: 0px 0px 8px rgba(83, 102, 163, 1);}
  .hotellist-region /deep/ .el-input__inner{padding:0 53px;height: 48px; background-image: url(/static/img/account/icon_u24.png);background-repeat: no-repeat;background-size: 23px;background-position: 15px center;border: 1px solid #DCDFE6;}
  .hotellist-region /deep/ .el-popover--plain{width:100%;padding:0px;color: #FF6B6D;top: -33px;font-size:12px;height: 28px;line-height: 28px;z-index: 2001;text-align:center;}

  /* 订单状态 */
  .search-status{width:170px;float: left;margin-right:5px;}
  .search-status .el-select{width: 100% !important;}
  .search-status /deep/ .el-input__inner{height: 48px;border: 1px solid #DCDFE6;}

  /* 日期 */
  /deep/ .el-popper[x-placement^=bottom]{margin-top: 5px;}
  /deep/ .el-popper[x-placement^=top]{margin-bottom: 0px;}
  .hotellist-date-all /deep/ .el-input__inner{border: 1px solid #DCDFE6;}
  .hotellist-date-all /deep/ .el-input__inner:focus{box-shadow: 0px 0px 8px rgba(83, 102, 163, 1);}
  .hotellist-date-all /deep/ .el-input__inner:focus, /deep/ .hotellist-date-all input:focus{border-color:rgba(83, 102, 163, 1);box-shadow: 0px 0px 8px rgba(83, 102, 163, 1);}

  .hotellist-date-all{height:100%;width:260px;display:inline-block;vertical-align: top;cursor:pointer;position: relative;}
  .hotellist-date{padding: 0px;width: 30%; height: 48px;font-size: 16px;opacity:1;}
  .hotellist-date .hotellist-date-start{float:left;width: 37%;height: 100%;/*text-indent: 0.5rem;*/line-height: 27px; font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;  font-weight: 650; font-style: normal; color: #4F4C4C;font-size: 14px;}
  .hotellist-date .hotellist-date-start-left{width: 38%;}
  .hotellist-date .hotellist-date-start .hotellist-date-start-date{width: 100%;height: 24px;line-height: 28px;}
  .hotellist-date .hotellist-date-start .hotellist-date-start-week{width: 100%;height: 24px;font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;color: #999999;line-height: 18px;}
  .hotellist-date .hotellist-date-line{float:left;width:3%;height: 50%;line-height: 40px; text-align: right;}
  .hotellist-date .hotellist-date-line img{width: 65%;height: 100%;}
  .hotellist-date .hotellist-date-end{float:right;width: 38%;height: 100%;/*text-indent: 1rem;*/line-height: 27px; font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;  font-weight: 650; font-style: normal; color: #4F4C4C;font-size: 14px;}
  .hotellist-date .hotellist-date-end .hotellist-date-end-date{width: 100%;height: 24px;line-height: 28px;}
  .hotellist-date .hotellist-date-end .hotellist-date-end-week{width: 100%;height: 24px;font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;color: #999999;line-height: 18px;}
  .hotellist-date-all .hotellist-date-time-show{position:absolute;left:0px;top:0px;margin-top: 6px;}
  .el-range-editor.el-input__inner{display:inline-block;}
  .el-date-editor--daterange.el-input__inner{ width:100%;}
  .input-date-icon{background-image:url(https://res.roompai.com/static/img/input-date.png);background-repeat:no-repeat;background-size: 20px;background-position: 0px center;}
  /deep/ .hotellist-date .el-range-separator{display:none!important;}
  .hotellist-date .el-range__icon{margin-left:0px;}
  .hotellist-date-all .hotellist-date-show{border-color:rgba(83, 102, 163, 1);box-shadow: 0px 0px 8px rgba(83, 102, 163, 1);}
  .date-inner{border-radius: 4px;border: 1px solid #DCDFE6;box-sizing: border-box;color: #606266;display: inline-block;font-size: inherit;margin: 0em;background-color:rgba(255,255,255,1);width: 100%; height: 48px;opacity:1; cursor: pointer;font-size: 12px;}
  .date-inner .date-inner-start{width: 49%;height: 100%;float:left;overflow:hidden;}
  .date-inner .date-inner-division{border-right: solid 1px #797979;width: 1%;height: 100%;line-height: 45px;float:left;overflow:hidden}
  .date-inner .date-inner-end{width: 49%;height: 100%;line-height: 45px;float:left;overflow:hidden;}
  .date-inner .date-inner-check-img{width: 40px;height: 100%;background-image:url(https://res.roompai.com/static/img/input-date.png);background-repeat:no-repeat;background-size: 20px;background-position: 10px center;float:left;}
  .date-inner .date-inner-check-info{height: 100%;width:55%;float:left;}
  .date-inner .date-inner-check-str{width: 100%;height: 50%;line-height: 30px;}
  .date-inner .date-inner-check-date{width: 100%;height: 50%;line-height: 17px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;}
  /deep/ .el-range-editor.is-active, /deep/ .el-range-editor.is-active:hover, /deep/ .el-select .el-input.is-focus .el-input__inner{border-color:rgba(83, 102, 163, 1);}
  /deep/ .el-date-table td.end-date span, /deep/ .el-date-table td.start-date span{background-color: rgba(83, 102, 163, 1);}
  /* 按钮 */
  .input_button{ height: 48px !important; width: 7% !important; margin-left: 1% !important;}
  .view_button{margin: 15px 0 !important; width: 100px !important; height: 30px !important; float: right !important;}
  /deep/ .el-button{padding: 0;}
  /* 列表 */
  .coupon-list{background: #FFF; border-radius: 5px; padding:15px; position: relative;}
  .couponlist{width: 98%; background-color: rgba(242, 242, 242, 1);height: 40px;border: none; font-weight: 650; font-size: 14px; color: #333333; line-height: 40px; padding: 0 1%;border-radius: 5px;}
  .couponlist div, .hotel-info div{display:inline-block; float: left;}
  .hotel-info{ width: 98%; min-height:60px;height: auto; line-height: 60px; border: none; color: #333333;padding: 0 1%;border-bottom: 1px solid #d2cfcf; clear: both; font-size: 14px;}
  .no-text-back{color: #C0C4CC !important;}
  .no-date{background-color: #F5F7FA !important;border-color: #E4E7ED !important;color: #C0C4CC !important;cursor: not-allowed;}
  .type-list div{display: inline-block;margin-left: 15px; height: 40px; width: 100px; border: none; background-color:  rgba(215, 215, 215, 1); text-align: center; line-height: 40px; font-size: 14px;border-radius: 5px 5px 0 0; cursor: pointer;}
  .gray-background{ background-color:rgba(242, 242, 242, 1) !important;}
  .width-discount{width: 20%;}
  .width-type{width: 13%;}
  .width-price{width: 14%;}
  .width-validity{width: 20%;}
  .width-checkin, .width-checkout{width: 9%;}
  .width-button{width: 15%;}
  /* 骨架屏 */
  .template-text{width: 80%;margin: 13.5px 0;}
  .template-info-text{width: 80%;margin: 19px 0;}
  .coupon-list /deep/ .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover, .hotel-info  /deep/ .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover{box-shadow: none;}
  .coupon-list /deep/ .el-card{border: none;}
  @media only screen and (max-width:1500px){
    /deep/ .el-popper[x-placement^=bottom]{left: 471px !important;}
  }

</style>



// WEBPACK FOOTER //
// src/components/account/myCoupon.vue